import cls from './PremiumPage.module.scss'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { navActions } from 'entities/NavMenu'
import { authActions } from 'features/anonymousAuth'
import React from 'react'
import logo from 'shared/assets/MineCards-Logo-Premium.svg'
import background from 'shared/assets/images/premiumBackground.png'
import { BackIcon, DreamIcon } from 'shared/ui/Icon'
import {
    Text,
    TextAlign,
    TextColor,
    TextSize,
    TextWeight,
} from 'shared/ui/Text/Text'
import { Button } from 'shared/ui/Button'
import { ColorEnum } from 'shared/ui/Button/ui/Button'
import {
    activateCurrentPremium,
    premiumActivationMessage,
} from 'shared/api/activateCurrentPremium'

export const PremiumPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [activationPending, setActivationPending] = useState(false)
    const [activationError, setActivationError] = useState('')

    const onActivatePremium = async () => {
        if (activationPending) {
            return
        }

        setActivationPending(true)
        setActivationError('')
        try {
            await activateCurrentPremium()
            dispatch(authActions.setPremium(true))
            navigate('/', {
                replace: true,
                state: { toast: premiumActivationMessage },
            })
        } catch (error) {
            console.error('Premium activation failed', error)
            setActivationError(
                'Не удалось подключить Premium. Попробуй ещё раз.'
            )
            setActivationPending(false)
        }
    }

    const onBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        dispatch(navActions.setVisible(false))
    }, [dispatch])

    return (
        <div className={cls.scrollable}>
            <div className={cls.premiumPage}>
                <Button onClick={onBack} className={cls.back}>
                    <BackIcon />
                </Button>
                <div className={cls.ImageContainer}>
                    <img className={cls.Image} alt="MineCards" src={logo} />
                </div>
                <div className={cls.titleContainer}>
                    <Text size={TextSize.XL} weight={TextWeight.BOLD}>
                        MineCards
                    </Text>
                    <Text
                        color={TextColor.ORANGEGRADIENT}
                        size={TextSize.XL}
                        weight={TextWeight.BOLD}
                    >
                        Premium
                    </Text>
                </div>
                <Text className={cls.Text}>
                    Безлимитный доступ к лучшим идеям и мечтам
                </Text>
                <div className={cls.privilegesContainer}>
                    <div className={cls.privelege}>
                        <DreamIcon className={cls.PrivilegeIcon} />
                        Безлимитные мечты в ленте
                    </div>
                    <div className={cls.privelege}>
                        <DreamIcon className={cls.PrivilegeIcon} />
                        Секретный MineCards чат
                    </div>
                    <div className={cls.privelege}>
                        <DreamIcon className={cls.PrivilegeIcon} />
                        Твоё имя в титрах
                    </div>
                </div>
                <Text
                    className={cls.footerText}
                    align={TextAlign.LEFT}
                    weight={TextWeight.REG}
                >
                    Поддерживая нас, ты становишься частью MineCards движения —
                    помогать осуществлять мечты
                    <DreamIcon className={cls.InlineIcon} />
                </Text>
                <Button
                    color={ColorEnum.ORANGE}
                    className={cls.Button}
                    onClick={onActivatePremium}
                    disabled={activationPending}
                >
                    <div className={cls.buttonWrapper}>
                        <Text weight={TextWeight.SBOLD}>
                            Подписаться от 49₽ в месяц
                        </Text>
                        <Text size={TextSize.XS} weight={TextWeight.SBOLD}>
                            (при оплате за год)
                        </Text>
                    </div>
                </Button>
                {activationError ? (
                    <div className={cls.activationError} role="alert">
                        {activationError}
                    </div>
                ) : null}
            </div>
            <img className={cls.background} src={background} alt="background" />
            <div className={cls.gradient} />
        </div>
    )
}
